/* TWD Instagram videos.
   - Each card is a real video file. With data-autoplay="true" a video plays muted on a loop while it is on screen and pauses when it
     leaves (so only the visible few ever load or play). With autoplay off the card shows its cover and plays when tapped.
   - If a browser refuses to autoplay (iOS Low Power Mode, data saver, strict settings) the card shows a play badge instead, and the
     first tap, scroll or click anywhere retries every visible video.
   - The speaker button turns sound on for that video (and mutes any other). Browsers only allow sound after a tap, so it starts muted.
   - data-rotate="N" slides to the next videos every N seconds. It pauses on hover, touch, focus, while sound is on, and never runs for
     shoppers who prefer reduced motion.
   - Every card also links to the reel on Instagram (corner icon + "Watch on Instagram" under the title).
   - Re-initialises when the theme editor reloads the section (shopify:section:load). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__twdReels) return;
    root.__twdReels = true;

    var track = root.querySelector('.tw-reels__track');
    var prev = root.querySelector('[data-dir="-1"]'), next = root.querySelector('[data-dir="1"]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var rotateSecs = parseInt(root.getAttribute('data-rotate'), 10) || 0;
    var cards = [].slice.call(track.querySelectorAll('.tw-reel'));
    var videos = cards.map(function (c) { return c.querySelector('video'); });
    var userHold = false;

    function step() { var c = track.querySelector('.tw-reel'); return c ? c.getBoundingClientRect().width + 16 : 300; }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    function sync() { prev.disabled = track.scrollLeft <= 2; next.disabled = atEnd(); }

    [prev, next].forEach(function (b) {
      b.addEventListener('click', function () { userHold = true; track.scrollBy({ left: step() * Number(b.dataset.dir), behavior: 'smooth' }); });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    function load(v) {
      if (!v.getAttribute('src') && v.dataset.src) {
        v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
        v.src = v.dataset.src;
        v.load();
      }
    }
    function tryPlay(v) {
      load(v);
      var card = v.closest('.tw-reel');
      var p = v.play();
      if (p && p.then) {
        p.then(function () { card.classList.remove('needs-tap'); card.classList.add('is-playing'); })
         .catch(function () { card.classList.add('needs-tap'); card.classList.remove('is-playing'); });
      }
    }
    function visible(v) {
      var b = v.getBoundingClientRect(), t = track.getBoundingClientRect();
      var w = Math.min(b.right, t.right) - Math.max(b.left, t.left);
      var h = Math.min(b.bottom, window.innerHeight) - Math.max(b.top, 0);
      return w > b.width * 0.5 && h > Math.min(b.height, window.innerHeight) * 0.35;
    }
    function setSoundUi(v) {
      var btn = v.parentNode.querySelector('.tw-reel__sound');
      var on = !v.muted;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
    }
    function muteOthers(except) { videos.forEach(function (v) { if (v !== except && !v.muted) { v.muted = true; setSoundUi(v); } }); }
    function anySound() { return videos.some(function (v) { return !v.muted && !v.paused; }); }

    // play only what is on screen (viewport observer: also respects the sideways clipping of the row)
    function onVisible(v, isVisible) {
      if (isVisible) { if (autoplay && v.paused) tryPlay(v); else load(v); }
      else if (!v.paused) { v.pause(); }
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { onVisible(en.target, en.isIntersecting && visible(en.target)); });
      }, { threshold: [0, 0.25, 0.5, 0.75] });
      videos.forEach(function (v) { io.observe(v); });
    } else {
      videos.forEach(function (v) { onVisible(v, visible(v)); });
    }
    // belt and braces: also check after scrolling stops and after the first user gesture
    var settle;
    function recheck() { videos.forEach(function (v) { onVisible(v, visible(v)); }); }
    track.addEventListener('scroll', function () { clearTimeout(settle); settle = setTimeout(recheck, 250); }, { passive: true });
    window.addEventListener('scroll', function () { clearTimeout(settle); settle = setTimeout(recheck, 250); }, { passive: true });
    ['touchstart', 'click', 'keydown'].forEach(function (ev) { window.addEventListener(ev, recheck, { once: true, passive: true }); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) videos.forEach(function (v) { v.pause(); }); else recheck(); });
    videos.forEach(function (v) { v.addEventListener('loadeddata', function () { if (autoplay && v.paused && visible(v)) tryPlay(v); }); });

    // sound button, and tap-to-play (autoplay off, or the browser refused to autoplay)
    cards.forEach(function (card, i) {
      var v = videos[i], btn = card.querySelector('.tw-reel__sound');
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        load(v);
        if (v.muted) { muteOthers(v); v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.muted = true; }
        setSoundUi(v);
      });
      card.querySelector('.tw-reel__media').addEventListener('click', function (e) {
        if (e.target.closest('a') || e.target.closest('.tw-reel__sound')) return;
        if (autoplay && !card.classList.contains('needs-tap')) return;
        load(v);
        if (v.paused) { muteOthers(v); v.muted = false; v.play(); card.classList.add('is-playing'); card.classList.remove('needs-tap'); }
        else { v.pause(); card.classList.remove('is-playing'); }
        setSoundUi(v);
      });
    });

    // auto-rotate
    if (rotateSecs > 0 && !reduce) {
      var hold = function () { userHold = true; };
      var free = function () { userHold = false; };
      root.addEventListener('mouseenter', hold); root.addEventListener('mouseleave', free);
      root.addEventListener('focusin', hold); root.addEventListener('focusout', free);
      root.addEventListener('touchstart', hold, { passive: true });
      root.addEventListener('touchend', function () { setTimeout(free, 4000); }, { passive: true });
      setInterval(function () {
        if (userHold || document.hidden || anySound()) return;
        var r = root.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;       // only while on screen
        if (atEnd()) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
        else { track.scrollBy({ left: step(), behavior: 'smooth' }); }
      }, rotateSecs * 1000);
    }
    recheck();
  }

  function initAll() { document.querySelectorAll('[data-reels]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
